<!-- TrustBox widget - Mini -->
<div class="trustpilot-widget" id="trustbox" data-locale="en-GB" data-template-id="53aa8807dec7e10d38f59f32"
  data-businessunit-id="5e559cdc1d562000013d923b" [attr.data-style-height]="isMobile ? '50px' : '150px'" data-style-width="100%" data-theme="light">
  <a href="https://uk.trustpilot.com/review/airportr.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->